// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file MetadataListContext.tsx
 * @input Uses React createContext
 * @output Exports MetadataListContext for sharing config between MetadataList and MetadataListItem
 * @position Internal context; consumed by MetadataList.tsx and MetadataListItem.tsx
 */
import { createContext } from 'react';
export const MetadataListContext = /*#__PURE__*/createContext(null);
MetadataListContext.displayName = 'MetadataListContext';